// extracted by mini-css-extract-plugin
export default {"menu":"MobileMenu_menu__oNBx0","link":"MobileMenu_link__3GpFJ"};